module.exports = __webpack_public_path__ + "img/wave-up.14361710.svg";